module.exports = __webpack_public_path__ + "img/ios-bg-en.432648c5.png";